import { fetcher } from '../utils'

export default async (connectionKey: string, phoneNumber: string): Promise<void> =>
  fetcher(`/api/contact/summary/${connectionKey}/${phoneNumber}`, 'PUT', undefined)
